export const MAR_CARD_CONFIG: object = {
  marGrid: [
    [
      {
        militaryTime: "0000",
        text: "12am",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
      {
        militaryTime: "0100",
        text: "1am",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
      {
        militaryTime: "0200",
        text: "2am",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
      {
        militaryTime: "0300",
        text: "3am",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
      {
        militaryTime: "0400",
        text: "4am",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
      {
        militaryTime: "0500",
        text: "5am",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
    ],
    [
      {
        militaryTime: "0600",
        text: "6am",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
      {
        militaryTime: "0700",
        text: "7am",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
      {
        militaryTime: "0800",
        text: "8am",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
      {
        militaryTime: "0900",
        text: "9am",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
      {
        militaryTime: "1000",
        text: "10am",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
      {
        militaryTime: "1100",
        text: "11am",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
    ],
    [
      {
        militaryTime: "1200",
        text: "12pm",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
      {
        militaryTime: "1300",
        text: "1pm",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
      {
        militaryTime: "1400",
        text: "2pm",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
      {
        militaryTime: "1500",
        text: "3pm",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
      {
        militaryTime: "1600",
        text: "4pm",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
      {
        militaryTime: "1700",
        text: "5pm",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
    ],
    [
      {
        militaryTime: "1800",
        text: "6pm",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
      {
        militaryTime: "1900",
        text: "7pm",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
      {
        militaryTime: "2000",
        text: "8pm",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
      {
        militaryTime: "2100",
        text: "9pm",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
      {
        militaryTime: "2200",
        text: "10pm",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
      {
        militaryTime: "2300",
        text: "11pm",
        slotType: "empty",
        marArray: [],
        relativeMarArray: [],
        timeDisplay: "normal",
      },
    ],
  ],
};

export const data: object = {
  reasons: [
    { display: "Patient refused", value: "Patient refused" },
    {
      display: "Patient not at his/her bed",
      value: "patient not at his/her bed",
    },
    { display: "Other", value: "Other" },
  ],
};

export const marValidationMessage = {
  eleSignAccept: [{ type: "required", message: "Verification is required." }],
  electSignedBy: [{ type: "required", message: "Signed by is required." }],
  dosage: [
    { type: "maxlength", message: "Maximum 50 characters are allowed." },
    { type: "required", message: "Dosage is required." },
  ],
  other: [
    { type: "maxlength", message: "Maximum 75 characters are allowed." },
    { type: "required", message: "Other is required." },
  ],
  administeredNotes: [
    { type: "maxlength", message: "Maximum 500 characters are allowed." },
    { type: "required", message: "Note is required." },
  ],
  administeredNotes2: [
    { type: "maxlength", message: "Maximum 500 characters are allowed." },
  ],
};



// WEBPACK FOOTER //
// ./src/components/configurable/cards/mar-card/mar-card-config.ts